import {Base} from './base';
import { User } from '../db_models/user';
export class ClientInfo extends Base {
    data:User=<User>{};
}
